// src/js/components/size-chart-component.js
var SizeChartComponent = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      tabButton: "[tab-button]",
      tabContainer: "[tab-container]",
      closeButton: ".size-chart__close"
    };
    Fancybox.bind("[data-fancybox]");
  }
  connectedCallback() {
    this.tabButton = this.querySelectorAll(this.selectors.tabButton);
    this.closeButton = this.querySelector(this.selectors.closeButton);
    this.tabButton?.forEach((button) => {
      button?.addEventListener("click", () => {
        if (!button.classList.contains("active")) {
          this.swicthTabs(button);
        }
      });
    });
    this.closeButton?.addEventListener("click", () => {
      Fancybox.close();
    });
  }
  swicthTabs(button) {
    this.tabButton?.forEach((btn) => {
      if (btn.classList.contains("active")) {
        btn.classList.remove("active");
      }
    });
    const ActivetabContainer = this.querySelector(`${this.selectors.tabContainer}.active`);
    if (ActivetabContainer) {
      ActivetabContainer.classList.remove("active");
    }
    setTimeout(() => {
      button.classList.add("active");
    }, 10);
    const id = button.dataset.id;
    const tabContainer = this.querySelector(`${this.selectors.tabContainer}[data-id="${id}"]`);
    tabContainer.classList.add("active");
  }
};
customElements.define("size-chart-component", SizeChartComponent);
